module.exports = __webpack_public_path__ + "img/gettingQuestionsWrong2.bb354e5b.png";